import { STATUSES } from "actions/ActionTypes";
import { formatHeaders, handleErrors, triggerError } from "utils/Api";
import { notifSuccess } from "actions/FlashMessageActions";
import rootURL from "utils/RootURL";

const sendPostRequest = (type, status, item, params, headers) => ({
  type,
  item,
  status,
  params,
  headers,
});

const sendApi = (
  method,
  {
    endpoint,
    type,
    item,
    data,
    token,
    headers,
    message,
    error,
    callback,
    callbackError,
    postProcess,
  },
) => {
  item = item || endpoint.split("/").pop();

  return (dispatch) => {
    dispatch(sendPostRequest(type, STATUSES.STARTED, item, data));
    return new Promise((resolve, reject) =>
      fetch(rootURL(endpoint), {
        method,
        headers: formatHeaders(token, headers),
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then((json) => {
          if (json && !json.errorType) {
            // HACK to add uuid in GET_CAMPAIGN response
            if (type === "GET_CAMPAIGN") {
              const uuid = endpoint.split("/").pop();
              json.uuid = uuid;
            }

            dispatch(
              sendPostRequest(
                type,
                STATUSES.SUCCESSFUL,
                item,
                postProcess ? postProcess(json) : json,
                headers,
              ),
            );
            if (message) {
              dispatch(notifSuccess(message));
            }

            if (callback) {
              callback(json);
            }
          } else {
            // New Error System
            const e = {
              message: json.errorType,
              details: json.errorDetails,
            };

            dispatch(sendPostRequest(type, STATUSES.FAILED, item, {}));
            triggerError(dispatch, e, error);

            if (callbackError) {
              callbackError(e);
            }
          }

          return json;
        })
        .then(resolve)
        .catch((e) => {
          // Keep ancient error system for compatibility
          dispatch(sendPostRequest(type, STATUSES.FAILED, item, {}));
          triggerError(dispatch, e, error);

          if (callbackError) {
            callbackError(e);
          }
          reject(e);
        }),
    );
  };
};

export const getApi = (data) => sendApi("GET", data);

export const postApi = (data) => sendApi("POST", data);

export const putApi = (data) => sendApi("PUT", data);

export const patchApi = (data) => sendApi("PATCH", data);

export const delApi = (data) => sendApi("DELETE", data);

export const postFile = ({
  endpoint,
  type,
  item,
  data,
  token,
  headers,
  message,
  error,
  callback,
  callbackError,
}) => {
  const h = {
    Authorization: `Bearer ${token}`,
  };

  if (headers && headers.length > 0) {
    headers.map((header) => (h[header.key] = header.value));
  }

  return (dispatch) => {
    dispatch(sendPostRequest(type, STATUSES.STARTED, item, data));
    return fetch(rootURL(endpoint), {
      method: "POST",
      headers: h,
      body: data,
    })
      .then(handleErrors)
      .then((json) => {
        dispatch(sendPostRequest(type, STATUSES.SUCCESSFUL, item, json));
        if (message) {
          dispatch(notifSuccess(message));
        }

        if (callback) {
          callback(json);
        }
      })
      .catch((e) => {
        dispatch(sendPostRequest(type, STATUSES.FAILED, item, {}));
        triggerError(dispatch, e, error);
        if (callbackError) {
          callbackError(e);
        }
      });
  };
};
